export default "__VITE_PUBLIC_ASSET__c70fa07e__"